'use client';

import { useTranslations } from 'next-intl';
import { z } from 'zod';

export function useInputSchema() {
  const t = useTranslations('Common');

  return {
    fullNameSchema: z.string().min(1, t('validation.required')).trim(),
  };
}
